import { BaseCamelCasedResource } from "./BasePlainResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export class ThirdPartyScriptSettingsResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        //	CookieBot
        this.loadCookieBot = false;
        // Giosg Chat
        this.loadGiosgChat = false;
        //	GTM
        this.loadGoogleTagManager = false;
        this.loadGoogleTagManagerExtended = false;
        //	Zendesk
        this.loadZendeskChat = false;
        this.loadDNBFIZendesk = false;
        //	Salesforce Embedded Messaging
        this.loadSalesforceChat = false;
    }
    pk() {
        return "ThirdPartyScriptSettings";
    }
}
ThirdPartyScriptSettingsResource.urlRoot = legacyApiResourceUrl("Login");
//# sourceMappingURL=ThirdPartyScriptSettingsResource.js.map